module.exports = __webpack_public_path__ + "img/RH2020_WILLYVANDERPERRE.37c161a5.png";